const jobs = {
  lastUpdated: '2022-01-25',
  jobs: [{
    role: 'pm',
    company: 'Asana',
    companyTag: 'asana',
    title: 'Product Manager, Growth Platform',
    salaryRange: '$171-258k',
    tags: ['SaaS'],
    location: 'San Francisco, CA',
    jobURL: 'https://asana.com/jobs/apply/4665714',
  }, {
    role: 'em',
    company: 'Loom',
    companyTag: 'loom',
    title: 'Senior Engineering Manager',
    tags: ['SaaS'],
    location: 'San Francisco, CA',
    remote: true,
    jobURL: 'https://boards.greenhouse.io/loominc/jobs/4149140005?src=Exponent',
  }, {
    role: 'pm',
    company: 'Retool',
    companyTag: 'retool',
    title: 'Product Manager, Connect',
    tags: ['SaaS', 'B2B'],
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/retool/jobs/4218200005',
  }, {
    role: 'swe',
    company: 'Webflow',
    companyTag: 'webflow',
    title: 'Software Engineer',
    salaryRange: '$130-198k',
    tags: ['SaaS'],
    remote: true,
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/webflow/jobs/4873176',
  }, {
    role: 'swe',
    company: 'Cribl',
    companyTag: 'cribl',
    title: 'Staff Site Reliability Engineer',
    salaryRange: '$125-243k',
    tags: ['SaaS', 'B2B'],
    remote: true,
    jobURL: 'https://cribl.io/job-detail/?gh_jid=4765612004',
  }, {
    role: 'swe',
    company: 'Cribl',
    companyTag: 'cribl',
    title: 'Senior Full Stack Engineer',
    salaryRange: '$107-208k',
    tags: ['SaaS', 'B2B'],
    remote: true,
    jobURL: 'https://cribl.io/job-detail/?gh_jid=4801693004',
  }, {
    role: 'swe',
    company: 'Persona',
    companyTag: 'persona',
    title: 'Software Engineer, Product',
    salaryRange: '$107-208k',
    tags: ['SaaS', 'B2B'],
    location: 'New York, NY',
    jobURL: 'https://jobs.lever.co/persona/0c236072-71a6-44b9-ad21-2180fb2e8768',
  }, {
    role: 'swe',
    company: 'Persona',
    companyTag: 'persona',
    title: 'Solutions Engineer',
    salaryRange: '$107-208k',
    tags: ['SaaS', 'B2B'],
    location: 'New York, NY',
    jobURL: 'https://jobs.lever.co/persona/322a99fa-06ae-48c7-8247-b23c4c9de23a',
  }, {
    role: 'swe',
    company: 'Asana',
    companyTag: 'asana',
    title: 'Senior Software Engineer',
    salaryRange: '$171-258k',
    tags: ['SaaS'],
    location: 'San Francisco, CA',
    jobURL: 'https://asana.com/jobs/apply/4762661',
  }, {
    role: 'em',
    company: 'Retool',
    companyTag: 'retool',
    title: 'Engineering Manager',
    tags: ['SaaS', 'B2B'],
    location: 'San Francisco, CA',
    jobURL: 'https://retool.com/careers/engineering-manager-retooldb--engineering--san-francisco-ca',
  }, {
    role: 'swe',
    company: 'Outschool',
    companyTag: 'outschool',
    title: 'Software Engineer, Growth',
    salaryRange: '$144-185k',
    tags: ['Edtech'],
    remote: true,
    jobURL: 'https://boards.greenhouse.io/outschool/jobs/4043830006?gh_src=a44b7ef86us',
  }, {
    role: 'em',
    company: 'Ro',
    companyTag: 'ro',
    title: 'Engineering Manager',
    salaryRange: '$190-236k',
    tags: ['Healthtech'],
    remote: true,
    jobURL: 'https://jobs.lever.co/ro/3732dff5-88e6-41e2-89f3-dffd90626981',
  }, {
    role: 'pm',
    company: 'Ro',
    companyTag: 'ro',
    title: 'Senior Product Manager',
    salaryRange: '$177-212k',
    tags: ['Healthtech'],
    remote: true,
    jobURL: 'https://jobs.lever.co/ro/bcd30c48-900d-461e-8a22-9f59528b2ea2',
  }, {
    role: 'em',
    company: 'Asana',
    companyTag: 'asana',
    title: 'Engineering Manager, Core Storage',
    salaryRange: '$220-336k',
    tags: ['SaaS'],
    location: 'San Francisco, CA',
    jobURL: 'https://asana.com/jobs/apply/4001726',
  }, {
    role: 'swe',
    company: 'Retool',
    companyTag: 'retool',
    title: 'Software Engineer',
    tags: ['SaaS', 'B2B'],
    location: 'San Francisco, CA',
    jobURL: 'https://retool.com/careers/software-engineer--engineering--san-francisco-ca',
  }, {
    role: 'pm',
    company: 'Amplitude',
    companyTag: 'amplitude',
    title: 'Senior Product Manager, Monetization',
    salaryRange: '$177-212k',
    tags: ['SaaS'],
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/embed/job_app?token=6636704002',
  }, {
    role: 'swe',
    company: 'Amplitude',
    companyTag: 'amplitude',
    title: 'Senior Software Engineer',
    salaryRange: '$151-252k',
    tags: ['SaaS'],
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/embed/job_app?token=6596646002',
  }, {
    role: 'pm',
    company: 'Capital One',
    companyTag: 'capital-one',
    title: 'Senior Product Manager, Search',
    salaryRange: '$195-222k',
    tags: ['Fintech'],
    location: 'New York, NY',
    jobURL: 'https://www.capitalonecareers.com/job/-/-/1732/45290504976',
  }, {
    role: 'em',
    company: 'Capital One',
    companyTag: 'capital-one',
    title: 'Senior Engineering Manager',
    salaryRange: '$195-278k',
    tags: ['Fintech'],
    location: 'New York, NY',
    jobURL: 'https://www.capitalonecareers.com/job/-/-/1732/45290505072',
    remote: true,
  }, {
    role: 'pm',
    company: 'Databricks',
    companyTag: 'databricks',
    title: 'Product Manager, Delta Lake',
    salaryRange: '$195-222k',
    tags: ['B2B'],
    location: 'San Francisco, CA',
    remote: true,
    jobURL: 'https://www.databricks.com/company/careers/product/product-manager-delta-lake-all-levels-6487593002',
  }, {
    role: 'pm',
    company: 'DoorDash',
    companyTag: 'doordash',
    title: 'Product Manager, Multiple Levels',
    salaryRange: '$144-282k',
    tags: ['B2C'],
    location: 'San Francisco, CA',
    remote: true,
    jobURL: 'https://careers.doordash.com/jobs/product-manager-multiple-levels-4894614',
  }, {
    role: 'pm',
    company: 'Snap',
    companyTag: 'snap',
    title: 'Product Manager, Creative Tools',
    salaryRange: '$175-250k',
    tags: ['Social'],
    location: 'San Francisco, CA',
    remote: true,
    jobURL: 'https://wd1.myworkdaysite.com/en-US/recruiting/snapchat/snap/job/Los-Angeles-California/Product-Manager--Creative-Tools_R0030426',
  }, {
    role: 'pm',
    company: 'Figma',
    companyTag: 'figma',
    title: 'Product Manager, FigJam',
    salaryRange: '$175-250k',
    tags: ['SaaS'],
    location: 'New York, NY',
    remote: true,
    jobURL: 'https://boards.greenhouse.io/figma/jobs/4808165004',
  }, {
    role: 'pm',
    company: 'Notion',
    companyTag: 'notion',
    title: 'Product Manager, Core Product',
    tags: ['SaaS', 'Productivity'],
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/notion/jobs/5264943003',
  }, {
    role: 'pm',
    company: 'Sentry',
    companyTag: 'sentry',
    title: 'Senior Product Manager, Core Product',
    tags: ['SaaS', 'Productivity'],
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/sentry/jobs/4851937',
  }, {
    role: 'pm',
    company: 'Chegg',
    companyTag: 'chegg',
    title: 'Senior Product Manager',
    tags: ['Edtech'],
    location: 'Santa Clara, CA',
    jobURL: 'https://osv-chegg.wd5.myworkdayjobs.com/Chegg/job/Santa-Clara-CA/Senior-Product-Manager_R2802-1',
  }, {
    role: 'pm',
    company: 'Wise',
    companyTag: 'wise',
    title: 'Product Director',
    salaryRange: '$280-360k',
    tags: ['Fintech'],
    location: 'Austin, TX',
    remote: true,
    jobURL: 'https://boards.greenhouse.io/transferwise/jobs/4798487',
  }, {
    role: 'em',
    company: 'Mercury',
    companyTag: 'mercury',
    title: 'Engineering Manager, Core Products',
    salaryRange: '$210-248k',
    tags: ['Fintech'],
    jobURL: 'https://boards.greenhouse.io/mercury/jobs/4781847004',
    remote: true,
  }, {
    role: 'pm',
    company: 'Mercury',
    companyTag: 'mercury',
    title: 'Senior Product Manager',
    salaryRange: '$150-207k',
    tags: ['Fintech'],
    jobURL: 'https://boards.greenhouse.io/mercury/jobs/4771166004',
    remote: true,
  }, {
    role: 'em',
    company: 'Reddit',
    companyTag: 'reddit',
    title: 'Engineering Manager, Ads',
    tags: ['Social'],
    salaryRange: '$198-297k',
    jobURL: 'https://boards.greenhouse.io/reddit/jobs/4832586',
    remote: true,
  }, {
    role: 'em',
    company: 'Dialpad',
    companyTag: 'dialpad',
    title: 'Manager, Data Engineering',
    tags: ['B2B'],
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/dialpad/jobs/6552258002',
    remote: true,
  }, {
    role: 'em',
    company: 'Curai Health',
    companyTag: 'curai',
    title: 'Engineering Manager, Product Engineering',
    tags: ['Healthtech'],
    salaryRange: '185-225k',
    jobURL: 'https://jobs.lever.co/curai/ddf42a74-c84d-4998-aa80-b0fc6a4aa4cf',
    remote: true,
  }, {
    role: 'swe',
    company: 'Curai Health',
    companyTag: 'curai',
    title: 'Senior Fullstack Engineer',
    tags: ['Healthtech'],
    jobURL: 'https://jobs.lever.co/curai/85d37a85-2402-4c23-ad85-ece69daf2563',
    location: 'Bay Area, CA',
    remote: true,
    salaryRange: '160-210k',
  }, {
    role: 'em',
    company: 'Render',
    companyTag: 'render',
    title: 'Engineering Manager, Product Experience',
    tags: ['Cloud', 'SaaS'],
    salaryRange: '170-220k',
    location: 'San Francisco, CA',
    jobURL: 'https://boards.greenhouse.io/render/jobs/4067282005?gh_src=8552c8fa5us',
    remote: true,
  }, {
    role: 'em',
    company: 'Chewy',
    companyTag: 'chewy',
    title: 'Software Development Manager, Mobile',
    tags: ['B2C'],
    location: 'Boston, MA',
    jobURL: 'https://careers.chewy.com/us/en/job/CHINUS4152299EXTERNALENUS/Software-Development-Manager-Mobile',
  }, {
    role: 'pm',
    company: 'Chewy',
    companyTag: 'chewy',
    title: 'Sr. Product Manager',
    tags: ['B2C'],
    salaryRange: '107-215k',
    location: 'Bellevue, WA',
    jobURL: 'https://careers.chewy.com/us/en/job/CHINUS4896456EXTERNALENUS/Sr-Product-Manager',
  }, {
    role: 'pm',
    company: 'Deel',
    companyTag: 'deel',
    title: 'Senior Product Manager, Payroll',
    tags: [],
    location: 'North America',
    remote: true,
    jobURL: 'https://jobs.ashbyhq.com/Deel/a0bd7c98-9060-4f8d-a45d-78be0de8f1e6',
  }],
};

export default jobs;
